/**
 * Map statusLabel → sheet accent color. Per B.3b.2: lead=purple, booking
 * (paid)=green, booking (unpaid)=orange, block=blue, free (new)=role-color
 * but for create-state we keep the role outline visible.
 *
 * Вынесено из BookingModal.tsx 1:1 (рэтчет держит файл на базлайне 560
 * строк — вынос освободил место под конфликт-гейт 409/force).
 */
export function statusAccent(statusLabel: string, formType: "booking" | "lead"): string {
  switch (statusLabel) {
    case "лид":      return "var(--purple)";
    case "оплачено": return "var(--green)";
    case "бронь":    return "var(--orange)";
    case "блок":     return "var(--blue)";
    case "свободно": return formType === "lead" ? "var(--purple)" : "var(--green)";
    default:         return "var(--surface-3)";
  }
}
